import React, { useState } from 'react';
import { useEffect, useCallback } from 'react';
import { withStyles } from '@mui/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { InputAdornment } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { useSelector } from 'react-redux';
// import MuiPhoneNumber from 'mui-phone-number';
// import { MuiTelInput } from 'mui-tel-input'



import { FormHelperText } from '@mui/material';

import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/material.css';

import InfoIcon from '@mui/icons-material/Info';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { customerBookingDetails } from '../../redux/actions/customerBookingDetails'; // Import your Redux action creator
import dayjs from 'dayjs';
import EmailIcon from '@mui/icons-material/Email';
import PersonIconPng from './images/2.svg';
import FlightIcon from '@mui/icons-material/Flight';
import HomeIcon from '@mui/icons-material/Home';
import Login from '../../containers/Login';
import { setCreateBookingResponse } from '../../redux/actions/createBookingActions';
// import { setPrivelegedResponse } from '../../redux/actions/privelegedAccountActions';
import IconButton from '@mui/material/IconButton';
import LuggageIcon from './images/1.svg';
import DownhillSkiingIcon from '@mui/icons-material/DownhillSkiing';
import GolfCourseIcon from '@mui/icons-material/GolfCourse';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import CircularProgress from '@mui/material/CircularProgress';
import { pushBookingContinue } from '../../gtm';
// import CustomPhoneInput from '../CustomPhoneInput';
import BusIcon from '@mui/icons-material/DirectionsBus'; // Import the bus icon
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import Tooltip from '@mui/material/Tooltip';
import ProgressBar from '../ProgressBar/ProgressBar';


const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#FCFDFD',
  },
  title: {
    textAlign: 'left',
    color: '#444',
    font: '20px arial,serif',
    fontFamily: 'Nexa,sans-serif',
    fontWeight: 'bold',
  },
  title2: {
    textAlign: 'center',
    fontSize: '2rem',
    fontWeight: '700',
    color: '#333',
    fontFamily: 'Nexa,sans-serif',
    lineHeight: '1.1',
    marginTop: '20px'
  },
  subtitle: {
    textAlign: 'left',
    font: '14px arial,serif',
    fontFamily: 'Nexa,sans-serif',
    color: '#444',
    marginTop: '18px',
  },
  subtitle1: {
    textAlign: 'center',
    fontSize: '1em',
    fontFamily: 'Nexa,sans-serif',
    color: '#444',
    fontWeight: '700',
  },
  button: {
    display: 'flex',
    justifyContent: 'flex-end',
    textTransform: 'none',
  },
  underline: {
    position: 'relative',
    display: 'inline-block',
  },
  underlineBefore: {
    position: 'absolute',
    content: '""',
    left: 50,
    right: 0,
    bottom: -8,
    height: '4px',
    width: '40%',
    backgroundColor: '#138911',
    borderRadius: '5px',
  },
  button1: {
    backgroundColor: 'rgb(17, 137, 17)',
    color: 'rgb(255, 255, 255)',
    borderRadius: '6px',
    marginTop: '14px',
    padding: '0px 50px',
    fontFamily: '"Nexa","Arial",sans-serif!important',
    fontWeight: 'bold',
    fontSize: '1rem',
    lineHeight: '1.75',
    letterSpacing: '0.02857em',
    minWidth: '183px',
    minHeight: '50px',
    display: 'flex',
  },
  luggageSection: {
    marginTop: '20px',
  },
  luggageTitle: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '10px',
  },
  luggageInfo: {
    marginLeft: '10px',
    color: '#999',
    fontSize: '0.875rem',
    display: 'flex',
    alignItems: 'center',
  },
  luggageButton: {
    display: 'flex',
    alignItems: 'center',
  },
  luggageIcon: {
    marginRight: '5px',
  },
  menuItem: {
    display: 'block',
    textAlign: 'center'
  },
});

const BookingJourneyForm = ({ classes, theme, history }) => {



  const currencySymbols = {
    GBP: '£', // British Pound
    USD: '$', // US Dollar
    EUR: '€', // Euro
    CAD: 'C$', // Canadian Dollar
    CHF: 'CHF', // Swiss Franc
    NOK: 'kr', // Norwegian Krone
    SEK: 'kr', // Swedish Krona
    AED: 'AED', // United Arab Emirates Dirham
    DKK: 'kr', // Danish Krone
  };





  const [inputProps, setInputProps] = useState({});

  const [emailAddressValue, setEmailAddress] = useState('');


  useEffect(() => {
    if (inputProps.autoFocus) {
      // Reset the inputProps to remove the autoFocus attribute
      setInputProps({});
    }
  }, [inputProps]);


  const preferedCountries = ['gb'];

  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

  // const apiBaseUrlV2 = process.env.REACT_APP_API_BASE_URL_API_V2_PROXY;

  const navigate = useNavigate();







  const dispatch = useDispatch();

  const travelDetails = useSelector(state => state.travelDetails);

  // Flight Label

  // Updated transport type mapping using destinationType values
  const transportTypeMapping = {
    AIR: {
      AIR: "Flight Number",
      BUS: "Bus Number",
      FERR: "Cruise Number",
      GOLF: "Flight Number",
      RES: "Flight Number",
      TRBU: "Train Number",
    },
    BUS: {
      AIR: "Bus Number",
      BUS: "Bus Number",
      FERR: "Bus Number",
      GOLF: "Bus Number",
      RES: "Bus Number",
      TRBU: "Bus Number",
    },
    FERR: {
      AIR: "Cruise Number",
      BUS: "Cruise Number",
      FERR: "Cruise Number",
      GOLF: "Cruise Number",
      RES: "Cruise Number",
      TRBU: "Cruise Number",
    },
    GOLF: {
      AIR: "Flight Number",
      BUS: "Bus Number",
      FERR: "Cruise Number",
      GOLF: "Tee Time",
      RES: "Pick Up Time",
      TRBU: "Train Number",
    },
    RES: {
      AIR: "Flight Number",
      BUS: "Bus Number",
      FERR: "Cruise Number",
      GOLF: "Tee Time",
      RES: "Pick Up Time",
      TRBU: "Train Number",
    },
    TRBU: {
      AIR: "Train Number",
      BUS: "Train Number",
      FERR: "Train Number",
      GOLF: "Train Number",
      RES: "Train Number",
      TRBU: "Train Number",
    },
  };

  // Function to get transport type based on destination types
  const getTransportType = (fromType, toType) => {
    if (transportTypeMapping[fromType] && transportTypeMapping[fromType][toType]) {
      return transportTypeMapping[fromType][toType];
    }
    return "Transport Number"; // Fallback if no mapping is found
  };

  //  Get transport types based on travel details
  const fromType = travelDetails.pickupValue.type; // e.g., 'AIR'
  const toType = travelDetails.dropoffValue.type;  // e.g., 'RES'

  const transportTypeOutbound = getTransportType(fromType, toType);
  const transportTypeReturn = getTransportType(toType, fromType);

  const { totalCost, } = useSelector((state) => state.booking);
  const formData = useSelector((state) => state.customer);

  const quoteResponse = useSelector(state => state.quoteResponse);

  const createBookingResponse = useSelector(state => state.createBooking);

  // A return booking has a second transfer in the basket, a one way booking only has the outbound
  const isReturnJourney = createBookingResponse.basket?.transfers?.length > 1;

  // One way bookings have no return leg, so there is nothing to tell the outbound one apart from
  const outboundTransportLabel = isReturnJourney ? `Outbound ${transportTypeOutbound}` : transportTypeOutbound;

  // Children Ages

  const [childAges, setChildAges] = useState(Array.from({ length: travelDetails.childrenCount }).map(() => ''));

  const defaultChildSeat = {
    code: "BABY",
    description: "Baby",
  };

  const [childSeats, setChildSeats] = useState(new Array(travelDetails.childrenCount.length).fill(defaultChildSeat));
  const [isChildAgeValid, setIsChildAgeValid] = useState(true);
  const [holdLuggageQty, setHoldLuggageQty] = useState(parseInt(travelDetails.adultsCount, 10) + parseInt(travelDetails.childrenCount.length, 10));
  const [skisSnowboardsQty, setSkisSnowboardsQty] = useState(0);
  const [bikesGolfBagsQty, setBikesGolfBagsQty] = useState(0);
  const [errors, setErrors] = useState({});
  const [showLoginComponent, setShowLoginComponent] = useState(false);
  const [showSubmitButton, setShowSubmitButton] = useState(true);
  const [isPickupChecked, setIsPickupChecked] = useState(true);
  const [resToRes, setResToRes] = useState(false);
  const [loading, setLoading] = useState(false);

  const [phone, setPhone] = useState('');
  const [lastNameChanged, setLastNameChanged] = useState(false);

  const [outboundBusStationError, setOutboundBusStationError] = useState(false);
  const [outboundBusNumberError, setOutboundBusNumberError] = useState(false);
  const [returnBusStationError, setReturnBusStationError] = useState(false);
  const [returnBusNumberError, setReturnBusNumberError] = useState(false);

  const handlePhone = useCallback((event) => {
    const phoneValue = event.currentTarget.value.replace(/\s+/g, '');
    let newErrors = { ...errors };

    if (!phoneValue) {
      newErrors.phone = 'Mobile phone number is required';
    } else {
      let phoneNumber;
      try {
        // Parse the phone number with 'GB' for UK numbers
        phoneNumber = parsePhoneNumberFromString(phoneValue, 'GB');
      } catch (error) {
        // Ignore parsing errors and move to custom validation
      }

      if (phoneNumber && phoneNumber.isValid()) {
        // Valid phone number by library standards

        let transfers = createBookingResponse.basket?.transfers.map(transfer => ({
          ...transfer,
          email: emailAddressValue,
          mobile: phoneValue,
        }));

        const newBody = {
          "basket": {
            "id": createBookingResponse.basket.id,
            "currency": {
              "code": createBookingResponse.basket.currency[0]
            },
            "transfers": transfers
          }
        };

        const headers = {
          'Content-Type': 'application/json'
        };

        fetch(`${apiBaseUrl}/basket/updateBasket`, {
          method: 'POST',
          headers,
          body: JSON.stringify(newBody),
        });

        delete newErrors.phone;
      } else {
        // Custom fallback for specific UK format (allows known valid UK patterns)
        const customUkPattern = /^(\+44)?7\d{8,9}$/;
        if (customUkPattern.test(phoneValue)) {
          // Clear errors but potentially add a warning if needed
          delete newErrors.phone;
        } else {
          // If neither library nor custom validation passes, set error
          newErrors.phone = 'Please enter a valid phone number';
        }
      }
    }

    setErrors(newErrors);
  }, [errors, apiBaseUrl, createBookingResponse, emailAddressValue]);


  // useEffect to trigger validation on component mount and when 'phone' changes
  useEffect(() => {
    if (lastNameChanged) {
      handlePhone({ currentTarget: { value: phone } });
      setLastNameChanged(false); // Reset the flag after handling
    }
  }, [phone, lastNameChanged, handlePhone]);

  // Email Validation
  const handleEmail = (event) => {
    let newErrors = { ...errors };
    // Validate Email on Blur
    const emailValue = event.currentTarget.value.trim();
    if (emailValue === '') {
      newErrors.email = 'Email Address is required';
    } else if (!isValidEmail(emailValue)) {
      newErrors.email = 'Invalid email format';
    } else {
      setEmailAddress(emailValue);
      delete newErrors.email; // No error
    }
    setErrors(newErrors);
  }
  // First Name Validation
  const handleFirstName = (event) => {
    let newErrors = { ...errors };
    // Validate First Name
    const firstNameValue = event.currentTarget.value.trim();

    if (firstNameValue === '') {
      newErrors.firstName = 'First Name is required';
    } else if (!/^[a-zA-Z\s]+$/.test(firstNameValue)) {
      newErrors.firstName = 'First Name should only contain letters and spaces';
    } else if (/^\d+$/.test(firstNameValue)) {
      newErrors.firstName = 'First Name should not contain numbers';
    } else {
      delete newErrors.firstName; // No error
    }

    setErrors(newErrors);
  }

  // Last Name Validation
  const handleLastName = (event) => {
    let newErrors = { ...errors };
    // Validate Last Name
    const lastNameValue = event.currentTarget.value.trim();
    setLastNameChanged(true);
    if (lastNameValue === '') {
      newErrors.lastName = 'Last Name is required';
    } else if (!/^[a-zA-Z\s]+$/.test(lastNameValue)) {
      newErrors.lastName = 'Last Name should only contain letters and spaces';
    } else if (/^\d+$/.test(lastNameValue)) {
      newErrors.lastName = 'Last Name should not contain numbers';
    } else {
      delete newErrors.lastName; // No error
    }
    setErrors(newErrors);
  }


  // Outbound Flight Number Validation
  const handleOutboundFlightNumber = (event) => {
    let newErrors = { ...errors };
    // Validate First Name
    const outboundFlightNumberValue = event.currentTarget.value.trim();

    if (outboundFlightNumberValue === '') {
      newErrors.outboundFlightNumber = `${outboundTransportLabel} is required`;
    } else {
      delete newErrors.outboundFlightNumber; // No error
    }
    setErrors(newErrors);
  }

  // Inbound Flight Number Validation
  const handleInboundFlightNumber = (event) => {
    let newErrors = { ...errors };
    // Validate First Name
    const inboundFlightNumberValue = event.currentTarget.value.trim();

    if (inboundFlightNumberValue === '') {
      newErrors.inboundFlightNumber = `Return  ${transportTypeReturn} is required`;
    } else {
      delete newErrors.inboundFlightNumber; // No error
    }
    setErrors(newErrors);
  }

  // Accodomation Name Validation
  const handleAccomodationName = (event) => {
    let newErrors = { ...errors };
    // Validate First Name
    const accomodationNameValue = event.currentTarget.value.trim();

    if (accomodationNameValue === '') {
      newErrors.accommodationName = 'Accommodation Name is required';
    } else {
      delete newErrors.accommodationName; // No error
    }
    setErrors(newErrors);
  }





  // Luggage Info Texts
  const LuggageLongText = (
      <div>
        <p>Please select how many items of hold/checked luggage you are bringing. This is the luggage you have checked in with your airline.</p>
        <ul>
          <li>Each passenger is entitled to one piece of hold luggage.</li>
          <li>This must be indicated on the booking.</li>
          <li>It must not exceed dimensions of 70cm x 40cm x 20cm.</li>
          <li>Carriage of any baggage exceeding these measurements will be subject to available baggage hold space and may be declined.</li>
        </ul>
      </div>
  );

  const SkisLongText = (
      <div>
        <p>If you plan on bringing skis or a snowboard with you on the transfer, it must be specified here on the booking form.</p>
        <ul>
          <li>Ski or snowboard bags should not exceed 190cm in length.</li>
          <li>Failure to notify us on the booking form of your intention to bring skis or a snowboard, or if the length of the items exceeds 190cm, may mean that we are unable to transport the items for you.</li>
        </ul>
      </div>
  );

  const GolfBagsLongText = (
      <div>
        <p>If you plan on bringing a bicycle with you on the transfer, it must be specified here on the booking form. All bicycles must be packed in an appropriate box or bag for transport and the maximum size for this is a length of 160cm, height of 100cm, and width of 40cm.</p>
        <ul>
          <li>If you plan on bringing a bike larger than this, please contact us to discuss your requirements.</li>
          <li>Failure to notify us on the booking form of your intention to bring a bicycle, or if the dimensions exceed those mentioned above, may mean that we are unable to transport the bicycle for you.</li>
        </ul>
      </div>
  );
  // Bus Details

  // Outbound Bus
  const [outboundBusNumber, setOutboundBusNumber] = React.useState(
      createBookingResponse?.basket?.transfers[0]?.transferType.code === "SCHD"
          ? null || 'DefaultFallbackValue'
          : 'DefaultFallbackValue'
  );

  const [outboundBusStation, setOutBoundBusStation] = React.useState(
      createBookingResponse?.basket?.transfers[0]?.transferType.code === "SCHD"
          ? null || 'DefaultFallbackValue'
          : 'DefaultFallbackValue'
  );



  // Return Bus
  const [returnBusNumber, setReturnBusNumber] = React.useState(
      createBookingResponse?.basket?.transfers[1]?.transferType.code === "SCHD"
          ? null || 'DefaultFallbackValue'
          : 'DefaultFallbackValue'
  );


  const [returnBusStation, setReturnBusStation] = React.useState(
      createBookingResponse?.basket?.transfers[1]?.transferType.code === "SCHD"
          ? null || 'DefaultFallbackValue'
          : 'DefaultFallbackValue'
  );




  const handleCheckboxChange = (event) => {
    setIsPickupChecked(event.target.checked);
  };




  const handleIncreaseHoldLuggage = () => {
    setHoldLuggageQty((prevQty) => {
      const newQty = Number(prevQty) + 1;

      return newQty;
    });
  };

  const handleDecreaseHoldLuggage = () => {
    if (holdLuggageQty > 0) {
      setHoldLuggageQty((prevQty) => {
        const newQty = Number(prevQty) - 1;

        return newQty;
      });
    }
  };


  const handleIncreaseSkisSnowboards = () => {
    setSkisSnowboardsQty((prevQty) => prevQty + 1);
  };

  const handleDecreaseSkisSnowboards = () => {
    if (skisSnowboardsQty > 0) {
      setSkisSnowboardsQty((prevQty) => prevQty - 1);
    }
  };

  const handleIncreaseBikesGolfBags = () => {
    setBikesGolfBagsQty((prevQty) => prevQty + 1);
  };

  const handleDecreaseBikesGolfBags = () => {
    if (bikesGolfBagsQty > 0) {
      setBikesGolfBagsQty((prevQty) => prevQty - 1);
    }
  };

  const childrenArray = [];


  // Check if there are children or infants
  if (createBookingResponse.basket?.transfers && createBookingResponse.basket?.transfers[0] && travelDetails.childrenCount.length && childAges.length && childSeats.length > 0) {
    for (let i = 0; i < travelDetails.childrenCount.length; i++) {

      childrenArray.push({
        id: `${createBookingResponse.basket.transfers[0].children[i].id}`,
        age: childAges[i],
        seatType: {
          code: childSeats[i].code,
          description: childSeats[i].description,
        },
      });
    }
  }


  // console.log("From Destination Type:", createBookingResponse?.basket?.transfers[1]?.toDestination?.destinationTypeCode);



  const childrenArray1 = [];

  // Check if there are children or infants
  if (createBookingResponse.basket?.transfers && createBookingResponse.basket?.transfers[1]) {
    if (travelDetails.childrenCount.length && childAges.length && childSeats.length > 0) {
      for (let i = 0; i < travelDetails.childrenCount.length; i++) {
        childrenArray1.push({
          id: `${createBookingResponse.basket.transfers[1].children[i].id}`,
          age: childAges[i], // Use the selected Child Age from state
          seatType: {
            code: childSeats[i].code, // Use the selected Child Seat's code from state
            description: childSeats[i].description, // Description based on the selected Child Seat from state
          },
        });
      }
    }
  }



  const handleSubmit = async (event) => {
    event.preventDefault();


    if (validateForm && Object.keys(errors).length <= 0) {
      // Gather Booking Continue for GTM
      // const bookingContinueDetails = {
      //   'DLV - transferName1': travelDetails.pickupValue.label,
      //   'DLV - transferName2': travelDetails.dropoffValue.label,
      //   'DLV - TY - Adults': travelDetails.adultsCount,
      //   'DLV - TY - Children': travelDetails.childrenCount + travelDetails.infantsCount,
      //   'DLV - TY - Date': travelDetails.outboundDate,
      // };

      const getQuoteDetails = {
        currency: quoteResponse.basket.currency[0],
        value: parseFloat((Math.round(createBookingResponse.basket.totalToPay) / 100).toFixed(2)),
        items: [{
          item_name: createBookingResponse.basket.transfers[0].fromDestination.name + " to " + createBookingResponse.basket.transfers[0].toDestination.name, // Name of the item
          price: parseFloat((Math.round(createBookingResponse.basket.totalToPay) / 100).toFixed(2)),
          item_category: createBookingResponse.basket.transfers[0].transferType.description,
          item_category2: createBookingResponse.basket.transfers.length > 1 ? "Return" : "One way", // Category based on number of transfers
          quantity: 1 // Quantity of the item
        }]
      }

      // Push the search event to the data layer
      pushBookingContinue(getQuoteDetails);



      if (!validateForm() || !showSubmitButton) {
        return;
      }

      // Validate phone again on submit
      // if (!validatePhone(phone)) {
      //   // If validation fails, update errors and prevent form submission
      //   setPhoneErrors({ ...phoneerrors, phone: 'Please enter a valid phone number' });
      //   return;
      // }


      setShowSubmitButton(false); // Hide the submit button

      // Set loading to true to show the loading status
      setLoading(true);

      // Get form data
      const data = new FormData(event.currentTarget);



      const newBookingDetails = {
        "basket": {
          "id": createBookingResponse.basket.id,
          "guid": quoteResponse.basket_id,
          "transfers": [
            {
              "id": createBookingResponse.basket.transfers[0].id,
              // "transferType": {
              //   "code": transferType,
              //   "description": short_description[0],
              //   "descriptionShort": [
              //     "<strong>No-wait door to door service check</strong>",
              //     "<strong>Private vehicle</strong> means no sharing or waiting.",
              //     "Departure pickup time <strong>tailored to your flight time</strong>, so no early departs or wasted time at the airport.",
              //     "Choose <strong>your own pick up time</strong> when booking if you prefer."
              //   ],
              //   "descriptionLong": [
              //     "A direct door to door service (where accommodation can be accessed by road). check",
              //     "<strong>A vehicle just for you or your group – no sharing with, or waiting for other passengers.</strong>",
              //     "Departure pick up time tailored to your flight time, so no early departs, or wasted time at the airport, due to other people’s flights.",
              //     "You can specify your own pick up time for the return leg of your journey when booking if you prefer.",
              //     "Confirmation of pick up time is sent to you by email and SMS by 17:00 (CET) the day prior to each journey, so no waiting in the cold for your transfer to arrive.",
              //     "Bikes, skis &amp; boards transferred free of charge, as long as they are specified on the booking form.",
              //     "Child &amp; baby seats provided free of charge as long as they ordered on the booking form.",
              //     "<em>Please ensure you have read and understand our Terms &amp; Conditions, which contain more detailed information, including about Luggage Allowance, Child Seats, waiting times in case of flights landing earlier or later than scheduled and the general Conditions of Carriage. If you have any questions, please don’t hesitate to ask us.</em>"
              //   ],
              //   "totalCost": totalCost,
              //   "costPerPerson": costPerPerson
              // },
              "shuttle": {
                "bus": {
                  "id": outboundBusNumber.id,
                  "description": outboundBusNumber.options
                },
                "departureStop": [{
                  "id": outboundBusStation.id,
                  "options": outboundBusStation.options
                }],
                "arrivalStop": [{
                  "id": returnBusStation.id,
                  "options": returnBusStation.options
                }]
              },
              "fromDestination": {
                "id": travelDetails.pickupValue.id,
                "name": travelDetails.pickupValue.label,
                "destinationTypeCode": "AIR",
                "destinationType": "Airport"
              },
              "toDestination": {
                "id": travelDetails.pickupValue.id,
                "name": travelDetails.pickupValue.label,
                "destinationTypeCode": "RES",
                "destinationType": "Resort"
              },
              "date": travelDetails.outboundDate,
              "time": travelDetails.outboundTime,
              "timeLabel": "Flight arrival time",
              "flightNumber": data.get('outboundFlightNumber'),
              "flightNumberLabel": "Flight number",
              "showFlightNumber": true,
              "flightTimeOverrideLabel": "I'm not traveling by plane/train",
              "showFlightTimeOverride": true,
              "flightTimeOverride": false,
              "adults": travelDetails.adultsCount,
              "children": childrenArray,
              "forename": data.get('firstName'),
              "surname": data.get('lastName'),
              "email": data.get('email'),
              "mobile": phone.replace(/\s/g, ''),
              "fromAccommodation": {
                "name": null,
                "street": null,
                "show": null
              },
              "toAccommodation": {
                "name": "",
                "street": "",
                "show": null
              },
              "numberOfBikes": bikesGolfBagsQty,
              "numberOfSkis": skisSnowboardsQty,
              "numberOfHoldItems": holdLuggageQty,
              "notes": data.get('notes'),
              "valid": true,
              "errors": []
            }
          ]
        }
      }

      // Assuming createBookingResponse and other variables are already defined

      // Check if there is a need to set both departure and arrival stops to returnBusStation details
      if (createBookingResponse.basket.transfers[0].fromDestination.destinationTypeCode === 'AIR' && createBookingResponse.basket.transfers[0].toDestination.destinationTypeCode === 'RES') {
        // Set both the departure and arrival stops to returnBusStation details
        newBookingDetails.basket.transfers[0].shuttle.departureStop = outboundBusStation
        newBookingDetails.basket.transfers[0].shuttle.arrivalStop = outboundBusStation
      }
      else if (createBookingResponse.basket.transfers[0].fromDestination.destinationTypeCode === 'RES' && createBookingResponse.basket.transfers[0].toDestination.destinationTypeCode === 'AIR') {
        // Set both the departure and arrival stops to returnBusStation details
        newBookingDetails.basket.transfers[0].shuttle.departureStop = outboundBusStation
        newBookingDetails.basket.transfers[0].shuttle.arrivalStop = outboundBusStation
      }


      // newBookingDetails now has the updated shuttle information as per the new requirement


      if (createBookingResponse.basket.transfers[0].fromAccommodation.show) {
        // Update "fromAccommodation" if show is true
        newBookingDetails.basket.transfers[0].fromAccommodation.name = data.get('accommodationName') ?? null;
        newBookingDetails.basket.transfers[0].fromAccommodation.street = data.get('accommodationAddress') ?? null;
        newBookingDetails.basket.transfers[0].fromAccommodation.show = true;

        // Reset "toAccommodation" if show is true for "fromAccommodation"
        newBookingDetails.basket.transfers[0].toAccommodation.name = data.get('pickupAccommodationName') ?? travelDetails.dropoffValue.label ?? null;
        newBookingDetails.basket.transfers[0].toAccommodation.street = data.get('pickupAccommodationAddress') ?? travelDetails.dropoffValue.label ?? null;
        newBookingDetails.basket.transfers[0].toAccommodation.show = false;
      } else if (createBookingResponse.basket.transfers[0].toAccommodation.show) {
        // Update "toAccommodation" if show is true
        newBookingDetails.basket.transfers[0].toAccommodation.name = data.get('accommodationName') ?? null;
        newBookingDetails.basket.transfers[0].toAccommodation.street = data.get('accommodationAddress') ?? null;
        newBookingDetails.basket.transfers[0].toAccommodation.show = true;

        // Reset "fromAccommodation" if show is true for "toAccommodation"
        newBookingDetails.basket.transfers[0].fromAccommodation.name =  data.get('pickupAccommodationName') ?? travelDetails.pickupValue.label ?? null;
        newBookingDetails.basket.transfers[0].fromAccommodation.street = data.get('pickupAccommodationAddress') ?? travelDetails.pickupValue.label ?? null;
        newBookingDetails.basket.transfers[0].fromAccommodation.show = false;
      }


      // Create an object with the booking journey details
      const bookingDetails = {
        "basket": {
          "id": createBookingResponse.basket.id,
          "guid": quoteResponse.basket_id,
          "currency": createBookingResponse.basket.currency,
          "transfers": [
            {
              "id": createBookingResponse.basket.transfers[0].id,
              // "transferType": {
              //   "code": transferType,
              //   "description": short_description[0],
              //   "descriptionShort": "",
              //   "descriptionLong": "",
              //   "totalCost": totalCost,
              //   "costPerPerson": costPerPerson
              // },
              "shuttle": {
                "bus": {
                  "id": outboundBusNumber.id,
                  "description": outboundBusNumber.options
                },
                "departureStop": returnBusStation,
                "arrivalStop": outboundBusStation
              },
              "fromDestination": {
                "id": travelDetails.pickupValue.id,
                "name": travelDetails.pickupValue.label,
                "destinationTypeCode": "AIR",
                "destinationType": "Airport"
              },
              "toDestination": {
                "id": travelDetails.dropoffValue.id,
                "name": travelDetails.dropoffValue.label,
                "destinationTypeCode": "RES",
                "destinationType": "Resort"
              },
              "date": travelDetails.outboundDate,
              "time": travelDetails.outboundTime,
              "timeLabel": "Flight arrival time",
              "flightNumber": data.get('returnFlightNumber'),
              "flightNumberLabel": "Flight number",
              "showFlightNumber": true,
              "flightTimeOverrideLabel": "I'm not traveling by plane/train",
              "showFlightTimeOverride": false,
              "flightTimeOverride": false,
              "adults": travelDetails.adultsCount,
              "children": childrenArray,
              "forename": data.get('firstName'),
              "surname": data.get('lastName'),
              "email": data.get('email'),
              "mobile": phone.replace(/\s/g, ''),
              "fromAccommodation": {
                "name": null,
                "street": null,
                "show": true
              },
              "toAccommodation": {
                "name": "",
                "street": "",
                "show": false
              },
              "numberOfBikes": bikesGolfBagsQty,
              "numberOfSkis": skisSnowboardsQty,
              "numberOfHoldItems": holdLuggageQty,
              "notes": data.get('notes'),
              "valid": true,
              "errors": []
            },

          ]
        }
      }

      // Assuming createBookingResponse, returnBusStation, and other necessary variables are already defined

      // Check if there is a need to set both departure and arrival stops to returnBusStation details based on destinationTypeCode
      if ((bookingDetails.basket.transfers[0].fromDestination.destinationTypeCode === 'AIR' && bookingDetails.basket.transfers[0].toDestination.destinationTypeCode === 'RES') || (bookingDetails.basket.transfers[0].fromDestination.destinationTypeCode === 'RES' && bookingDetails.basket.transfers[0].toDestination.destinationTypeCode === 'AIR')) {
        // Set both the departure and arrival stops to returnBusStation details
        bookingDetails.basket.transfers[0].shuttle.departureStop = [{
          "id": returnBusStation.id,
          "options": returnBusStation.options
        }];
        bookingDetails.basket.transfers[0].shuttle.arrivalStop = [{
          "id": returnBusStation.id,
          "options": returnBusStation.options
        }];
      }

      // bookingDetails now has the shuttle information updated based on the condition

      if (createBookingResponse.basket.transfers[0].fromAccommodation.show) {
        // Update "fromAccommodation" if show is true
        bookingDetails.basket.transfers[0].fromAccommodation.name = data.get('accommodationName');
        bookingDetails.basket.transfers[0].fromAccommodation.street = data.get('accommodationAddress') ?? null;
        bookingDetails.basket.transfers[0].fromAccommodation.show = true;

        // Reset "toAccommodation" if show is true for "fromAccommodation"
        bookingDetails.basket.transfers[0].toAccommodation.name = travelDetails.dropoffValue.label ?? null;
        bookingDetails.basket.transfers[0].toAccommodation.street = travelDetails.dropoffValue.label ?? null;
        bookingDetails.basket.transfers[0].toAccommodation.show = false;
      } else if (createBookingResponse.basket.transfers[0].toAccommodation.show) {
        // Update "toAccommodation" if show is true
        bookingDetails.basket.transfers[0].toAccommodation.name = data.get('accommodationName');
        bookingDetails.basket.transfers[0].toAccommodation.street = data.get('accommodationAddress') ?? null;
        bookingDetails.basket.transfers[0].toAccommodation.show = true;

        // Reset "fromAccommodation" if show is true for "toAccommodation"
        bookingDetails.basket.transfers[0].fromAccommodation.name = travelDetails.pickupValue.label ?? null;
        bookingDetails.basket.transfers[0].fromAccommodation.street = travelDetails.pickupValue.label ?? null;
        bookingDetails.basket.transfers[0].fromAccommodation.show = false;
      }




      // If there is return
      // Check if transfers[1] exists
      if (createBookingResponse.basket.transfers.length > 1) {
        // Create a new transfer object
        const newTransfer = {
          "id": createBookingResponse.basket.transfers[1].id,
          // "transferType": {
          //   "code": transferType,
          //   "description": short_description[0],
          //   "descriptionShort": "",
          //   "descriptionLong": "",
          //   "totalCost": totalCost,
          //   "costPerPerson": costPerPerson
          // },
          "shuttle": {
            "bus": {
              "id": returnBusNumber.id,
              "description": returnBusNumber.options
            },
            "departureStop": returnBusStation,
            "arrivalStop": outboundBusStation
          },
          "fromDestination": {
            "id": travelDetails.pickupValue.id,
            "name": travelDetails.pickupValue.label,
            "destinationTypeCode": "AIR",
            "destinationType": "Airport"
          },
          "toDestination": {
            "id": travelDetails.dropoffValue.id,
            "name": travelDetails.dropoffValue.label,
            "destinationTypeCode": "RES",
            "destinationType": "Resort"
          },
          "date": travelDetails.returnDate,
          "time": travelDetails.returnTime,
          "timeLabel": "Flight arrival time",
          "flightNumber": data.get('returnFlightNumber'),
          "flightNumberLabel": "Flight number",
          "showFlightNumber": true,
          "flightTimeOverrideLabel": "I'm not traveling by plane/train",
          "showFlightTimeOverride": false,
          "flightTimeOverride": false,
          "adults": travelDetails.adultsCount,
          "children": childrenArray1,
          "forename": data.get('firstName'),
          "surname": data.get('lastName'),
          "email": data.get('email'),
          "mobile": phone.replace(/\s/g, ''),
          "fromAccommodation": {
            "name": null,
            "street": null,
            "show": null
          },
          "toAccommodation": {
            "name": "",
            "street": "",
            "show": null
          },
          "numberOfBikes": bikesGolfBagsQty,
          "numberOfSkis": skisSnowboardsQty,
          "numberOfHoldItems": holdLuggageQty,
          "notes": data.get('notes'),
          "valid": true,
          "errors": []
        };

        // Check the condition to decide if departureStop and arrivalStop need to be updated
        if (newTransfer.fromDestination.destinationTypeCode === 'AIR' && newTransfer.toDestination.destinationTypeCode === 'RES') {
          // Update departureStop and arrivalStop to use the same returnBusStation details
          newTransfer.shuttle.departureStop = returnBusStation;
          newTransfer.shuttle.arrivalStop = returnBusStation;
        }
        else if (newTransfer.fromDestination.destinationTypeCode === 'RES' && newTransfer.toDestination.destinationTypeCode === 'AIR') {
          // Update departureStop and arrivalStop to use the same returnBusStation details
          newTransfer.shuttle.departureStop = returnBusStation;
          newTransfer.shuttle.arrivalStop = returnBusStation;
        }

        if (createBookingResponse.basket.transfers[1].fromAccommodation.show) {
          // Update "fromAccommodation" if show is true
          newTransfer.fromAccommodation.name = data.get('pickupAccommodationName') ?? null;
          newTransfer.fromAccommodation.street = data.get('pickupAccommodationAddress') ?? null;
          newTransfer.fromAccommodation.show = true;

          // Reset "toAccommodation" if show is true for "fromAccommodation"
          newTransfer.toAccommodation.name = data.get('accommodationName') ?? null;
          newTransfer.toAccommodation.street = data.get('accommodationAddress') ?? null;
          newTransfer.toAccommodation.show = false;
        } else if (createBookingResponse.basket.transfers[1].toAccommodation.show) {
          // Update "toAccommodation" if show is true
          newTransfer.toAccommodation.name = data.get('pickupAccommodationName') ?? null;
          newTransfer.toAccommodation.street = data.get('pickupAccommodationAddress') ?? null;
          newTransfer.toAccommodation.show = true;

          // Reset "fromAccommodation" if show is true for "toAccommodation"
          newTransfer.fromAccommodation.name = data.get('accommodationName') ?? null;
          newTransfer.fromAccommodation.street = data.get('accommodationAddress') ?? null;
          newTransfer.fromAccommodation.show = false;
        }
        // Add the new transfer object to the transfers array
        newBookingDetails.basket.transfers.push(newTransfer);

      }

      let busError = false;
      if (createBookingResponse?.basket?.transfers[0]?.transferType.code === 'SCHD') {
        if (outboundBusStation?.id === undefined || outboundBusStation === null) {
          setOutboundBusStationError(true);
          busError = true;
        } else {
          setOutboundBusStationError(false);
        }
        if (outboundBusNumber?.id === undefined || outboundBusNumber === null) {
          setOutboundBusNumberError(true);
          busError = true;
        } else {
          setOutboundBusNumberError(false);
        }
      }

      if (createBookingResponse.basket?.transfers[1]?.transferType.code === 'SCHD') {
        if (returnBusStation?.id === undefined || returnBusStation === null) {
          setReturnBusStationError(true);
          busError = true;
        } else {
          setReturnBusStationError(false);
        }
        if (returnBusNumber?.id === undefined || returnBusNumber === null) {
          setReturnBusNumberError(true);
          busError = true;
        } else {
          setReturnBusNumberError(false);
        }
      }
      if (busError) {
        setShowSubmitButton(true);
        setLoading(false);
        return;
      }


      const customerDetails = {
        email: data.get('email'),
        firstName: data.get('firstName'),
        lastName: data.get('lastName'),
        phone: phone.replace(/\s/g, ''),
        outboundFlightNumber: data.get('outboundFlightNumber'),
        accommodationName: data.get('accommodationName'),
        accommodationAddress: data.get('accommodationAddress') ?? "",
        holdLuggageQty,
        skisSnowboardsQty,
        bikesGolfBagsQty,
        outboundBusNumber: data.get('outboundBusNumber'),
        outboundBusStation: data.get('outboundBusStation'),
        returnBusStation: data.get('returnBusStation'),
        returnBusNumber: data.get('returnBusnumber')
        // Other properties of your state if any
      };

      // Add 'returnFlightNumber' only if there is more than one transfer
      if (createBookingResponse.basket.transfers.length > 1) {
        customerDetails.returnFlightNumber = data.get('returnFlightNumber');
        customerDetails.pickupAccommodationName = data.get('pickupAccommodationName');
        customerDetails.pickupAccommodationAddress = data.get('pickupAccommodationAddress') ?? "";
      }


      // email: data.get('email'),
      // firstName: data.get('firstName'),
      // lastName: data.get('lastName'),
      // phone: data.get('phone').replace(/\s/g, ''),
      // outboundFlightNumber: data.get('outboundFlightNumber'),
      // returnFlightNumber: data.get('returnFlightNumber'),
      // accommodationName: data.get('accommodationName'),
      // accommodationAddress: data.get('accommodationAddress'),
      // holdLuggageQty,
      // skisSnowboardsQty,
      // bikesGolfBagsQty,
      // Add other fields as needed

      // // Check if isPickupChecked is falsy
      // if (!isPickupChecked) {
      //   // Set "fromAccommodation" for transfers[0]
      //   newBookingDetails.basket.transfers[0].toAccommodation = {
      //     "name": data.get('accommodationName'),
      //     "street": data.get('accommodationAddress'),
      //     "show": true
      //   };
      //   customerDetails.pickupAccommodationName = data.get('pickupAccommodationName');
      //   customerDetails.pickupAccommodationAddress = data.get('pickupAccommodationAddress');
      //
      //   // Check if transfers[1] exists and update "fromAccommodation" for transfers[1]
      //   if (newBookingDetails.basket.transfers.length > 1) {
      //     newBookingDetails.basket.transfers[1].fromAccommodation = {
      //       "name": data.get('pickupAccommodationName'),
      //       "street": data.get('pickupAccommodationAddress'),
      //       "show": true
      //     };
      //   }
      // }


      // Make the API request for update basket
      try {
        const headers = {
          'Content-Type': 'application/json'
        };
        const response = await fetch(`${apiBaseUrl}/basket/updateBasket`, {
          method: 'POST',
          headers,
          body: JSON.stringify(newBookingDetails),
        });

        // // Temp
        // const response = {
        //   status:404,
        //   message: 'email does not belong to a privileged account'
        // }
        const responseData = await response.json();

        // Temp
        // const responseData = response;



        dispatch(setCreateBookingResponse(responseData))
        if (responseData) {
          const confirmProceed = await fetch(`${apiBaseUrl}/basket/proceed?basketId=${createBookingResponse.basket.id}&step=confirm`, {
            method: 'GET',
            headers
          });
          const confirmProceedResponse = await confirmProceed.json()

          if (confirmProceedResponse.user.allowGuest === false) {
            setLoading(false);
            // Show the Login Component
            setShowLoginComponent(true);

          } else if (confirmProceedResponse.user.allowGuest === true) {
            // Continue to navigate to "/terms" page
            navigate('/terms')

          }
        }
      } catch (error) {
        // Handle any other errors that may occur during the API call
      }


      // // Make the API request for Login
      // try {
      //   const headers = {
      //     'Content-Type': 'application/json',
      //     'Authorization': 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJpYXQiOjE2OTU1OTk2MzEsImV4cCI6MTg1MzI3OTYzMSwicm9sZXMiOlsiUk9MRV9VU0VSIl0sInVzZXJuYW1lIjoibGFyYXZlbGFwaSJ9.vwI8Gfx5wwKOEdb9D6kTs_zz-DiqUAkBepPg9APJkEnsKd99gTjbT4_0h6K5bArZfczlZmtVz-XAuNteVCEuct3V0fqjJctNkObdi3_CyOUqumP3Ts4gUQP-3dgTtKxYQOKA8ZF2uzeDVS10xbtwOzANC1HqarmHpDY9w3YqEpvyO-kXW4tYaoFhwo_XCeKIRv-QyvYMK-yV_sMcS9Km_p0lug5O_CK8IQbpRXZ_0Bxv8m2c2bRcOvNmBSV6X9QuHTcvFK9TiPQEvgZZu25MxHNAo7uWsqOoHfxYN42-2Twb9PtdVHda1mzJG_Rt-6koioCoaN5_dq1bMhicziWBeA',
      //     'Accept-Version': '2'
      //   };
      //   const response = await fetch(`${apiBaseUrlV2}/user/account/privileged`, {
      //     method: 'POST',
      //     headers,
      //     body: JSON.stringify({ user: { email: data.get('email') } }),
      //   });

      //   // // Temp
      //   // const response = {
      //   //   status:404,
      //   //   message: 'email does not belong to a privileged account'
      //   // }
      //   const responseData = await response.json();

      //   dispatch(setPrivelegedResponse(responseData))
      //   // Temp
      //   // const responseData = response;



      //   if (response.status === 200 ){
      //     if (responseData.message === 'privileged account found') {
      //       setLoading(false);
      //       // Show the Login Component
      //       setShowLoginComponent(true);


      //     }  else {

      //       // Handle other responses if needed
      //     }
      //   }
      //   // if(createBookingResponse.basket)
      //   else if(response.status === 404){
      //     if (responseData.message === 'email does not belong to a privileged account') {
      //       // Continue to navigate to "/terms" page
      //       navigate('/terms')

      //     }
      //   }
      //   else {

      //     // navigate('/terms')

      //     // Handle API errors here
      //   }
      // } catch (error) {
      //   // Handle any other errors that may occur during the API call
      //   // navigate('/terms')

      // }

      // Dispatch the action
      dispatch(customerBookingDetails(customerDetails));
    }
  };


  // Use useEffect to populate form fields with Redux data
  useEffect(() => {
    // Populate form fields with data from Redux when the component is loaded or reloaded
    const form = document.getElementById('booking-form');

    // Set the form fields' values using data from Redux
    form.email.value = formData.booking.email;
    form.firstName.value = formData.booking.firstName;
    form.lastName.value = formData.booking.lastName;
    form.outboundFlightNumber.value = formData.booking.outboundFlightNumber ?? '';
    form.phone.value = formData.booking.phone;
    // The 'returnFlightNumber' field is only rendered for return bookings
    if (isReturnJourney) {
      form.returnFlightNumber.value = formData.booking.returnFlightNumber ?? '';
    }

    if (createBookingResponse.basket.transfers[0].transferType.code !== "SCHD") {
      form.accommodationName.value = formData.booking.accommodationName;
      form.accommodationAddress.value = formData.booking.accommodationAddress ?? "";
    }


    // Add more fields as needed

  }, [formData, createBookingResponse.basket.transfers, isReturnJourney]);




  const validateForm = () => {
    const newErrors = {};
    const form = document.getElementById('booking-form');
    if (!form.checkValidity()) {
      form.reportValidity();
      return false;
    }


    //  // Phone number validation
    //  if (!phone) {
    //    newErrors.phone = 'Mobile phone number is required';
    //  } else {
    //   const internationalPhoneNumberPattern = /^\+[1-9]{1}[0-9]{1,14}(\s*[0-9]{1,4}){0,4}$/;
    //    if (!internationalPhoneNumberPattern.test(phone)) {
    //      newErrors.phone = 'Please enter a valid international phone number';
    //    }
    //  }


    // Check child age validation
    if (childAges.some((age) => age === '')) {
      setIsChildAgeValid(false); // Mark as invalid
      return false;
    }

    // Other validation checks...

    setIsChildAgeValid(true); // Mark as valid







    setErrors(newErrors);


    return Object.keys(newErrors).length === 0;
  };

  // Helper function to validate email format
  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };


  // Child Age
  const handleChildAgeChange = (event, index) => {


    // Create a copy of the current childAges array
    const newChildAges = [...childAges];

    // Update the value at the specified index with the new value
    newChildAges[index] = event.target.value;

    // Set the updated childAges state
    setChildAges(newChildAges);

    // Validate the child age selection
    const isValid = event.target.value !== '';
    setIsChildAgeValid(isValid);

  };


  const renderChildAgeError = () => {
    if (!isChildAgeValid) {
      return <div className="error-message">Please select child age for all children.</div>;
    }
    return null;
  };

  const handleChildSeatChange = (event, index) => {
    const selectedValue = event.target.value;

    // Define the mapping of user-friendly values to code values
    const valueToCode = {
      "Not Required": "None",
      "Baby": "BABY",
      "Booster": "BOOS",
    };

    // Get the code and description based on the selected value
    const code = valueToCode[selectedValue];
    const description = selectedValue;

    const newChildSeats = [...childSeats];
    newChildSeats[index] = { code, description };
    setChildSeats(newChildSeats);

  };

  useEffect(() => {
    if (createBookingResponse.basket.transfers[0]?.fromDestination.destinationTypeCode === 'RES'
        && createBookingResponse.basket.transfers[0]?.toDestination.destinationTypeCode === 'RES'
    ) {
      setResToRes(true);
      setIsPickupChecked(false);
    }
  }, [createBookingResponse]);

  // Add a useEffect to log the childSeats whenever it changes
  useEffect(() => {

  }, [childSeats]);

  const holdLuggage = travelDetails.adultsCount + travelDetails.childrenCount.length;

  return (
      <div>
        <Card sx={{ backgroundColor: '#f1f2f5', marginTop: '-12px', }}>
          <CardContent sx={{ backgroundColor: '#f1f2f5' }}>
            <Grid container spacing={2} sx={{
              flexGrow: 1,
              backgroundColor: '#f1f2f5'
            }}>
              <Grid item xs={12} md={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                <Typography variant="h5" sx={{
                  textAlign: 'left',
                  color: '#444',
                  font: '18px arial,serif',
                  fontFamily: 'Nexa,sans-serif',
                  fontWeight: 'bold', marginTop: '-10px',
                }}>
                  Your Transfers
                </Typography>
              </Grid>
              <Grid item xs={12} md={12}>
                <Typography variant="subtitle1" style={{
                  textAlign: 'left',
                  font: '12px arial,serif',
                  fontFamily: 'Nexa,sans-serif',
                  color: '#444',
                }}>
                  <span style={{ fontWeight: 'bold' }}>Outbound:</span> {travelDetails.pickupValue.label} To {travelDetails.dropoffValue.label} On The {dayjs(travelDetails.outboundDate).format('D MMM, YYYY')} At
                  <span> {travelDetails.outboundTime} For  </span>{travelDetails.adultsCount > 0 || travelDetails.childrenCount.length > 0 ? (
                    <span>
                    {travelDetails.adultsCount} Adults
                      {travelDetails.childrenCount.length > 0 &&
                          `, ${travelDetails.childrenCount.length} ${travelDetails.childrenCount.length > 1 ? 'Children' : 'Child'}`}
                      {`, Hold Luggage ${holdLuggage}`}
                  </span>
                ) : null}
                </Typography>
              </Grid>
              <hr />
              {createBookingResponse.basket.transfers[1] && (
                  <Grid item xs={12} md={12}>
                    <Typography variant="subtitle1" style={{
                      textAlign: 'left',
                      font: '12px arial,serif',
                      fontFamily: 'Nexa,sans-serif',
                      color: '#444',
                      marginTop: '-22px'
                    }}>
                      <span style={{ fontWeight: 'bold' }}>Inbound:</span> {travelDetails.dropoffValue.label} To {travelDetails.pickupValue.label} On  The {dayjs(travelDetails.returnDate).format('D MMM, YYYY')} At
                      <span> {travelDetails.returnTime} For  </span>{travelDetails.adultsCount > 0 || travelDetails.childrenCount.length > 0 ? (
                        <span>
                      {travelDetails.adultsCount} Adults
                          {travelDetails.childrenCount.length > 0 &&
                              `, ${travelDetails.childrenCount.length} ${travelDetails.childrenCount.length > 1 ? 'Children' : 'Child'}`}
                          {`, Hold Luggage ${holdLuggage}`}
                    </span>
                    ) : null}
                    </Typography>
                  </Grid>
              )}
              <Grid item xs={12} md={12}>
                <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                      textAlign: 'left',
                      color: '#444',
                      font: '16px arial,serif',
                      fontFamily: 'Nexa,sans-serif',
                      fontWeight: 'bold', marginTop: '-12px',
                    }}
                >
                  <Typography variant="h5" sx={{
                    textAlign: 'left',
                    color: '#444',
                    font: '14px arial,serif',
                    fontFamily: 'Nexa,sans-serif',
                    fontWeight: 'bold',
                    marginTop: '6px',
                    marginRight: '16px'
                  }}>
                    {createBookingResponse.basket.transfers.length > 1 && createBookingResponse.basket.transfers[0].transferType.description !== createBookingResponse.basket.transfers[1].transferType.description ? (
                        <>
                          <div>
                            Outbound Transfer Type: {createBookingResponse.basket.transfers[0].transferType.description}
                            &nbsp; &nbsp;
                            Inbound Transfer Type: {createBookingResponse.basket.transfers[1].transferType.description}
                          </div>
                        </>
                    ) : (
                        <div>Transfer Type: {createBookingResponse.basket.transfers[0].transferType.description}</div>
                    )}
                  </Typography>

                  <Typography variant="h5" sx={{
                    textAlign: 'left',
                    color: '#444',
                    font: '14px arial,serif',
                    fontFamily: 'Nexa,sans-serif',
                    fontWeight: 'bold', marginTop: '6px',
                  }}>
                    Total Price: {currencySymbols[createBookingResponse.basket.currency[0]]} {(Math.round(totalCost) / 100).toFixed(2)}
                  </Typography>
                </Box>

              </Grid>


            </Grid>
          </CardContent>
        </Card>

        <Grid
            container
            spacing={2}
            sx={{
              flexGrow: 1,
              backgroundColor: '#FCFDFD',
            }}
            className={`${classes.root} ${classes.spacing}`}
        >
          {/* Progress Bar Section */}
          <Grid
              item
              xs={12}
              md={12}
              style={{
                display: 'flex',
                justifyContent: 'center', // Right align for larger screens, center for smaller
                alignItems: 'center',
                padding: '10px',
              }}
          >
            <Grid xs={12}
                  md={9}
            >
              <ProgressBar currentStep={2} />
            </Grid>
          </Grid>
          {/* Heading Section */}
          <Grid
              item
              xs={12}
              md={12}
              style={{
                display: 'flex',
                justifyContent: 'center', // Center heading for small screens
                alignItems: 'center',
                textAlign: 'center',
                padding: '30px 10px 10px 10px',
              }}
          >
            <Typography
                variant="h2"
                sx={{
                  textAlign: 'center', // Center align for small screens
                  display: 'flex',
                  justifyContent: 'center', // Center align content
                  fontSize: '1.5rem',
                  fontWeight: '700',
                  color: '#333',
                  fontFamily: 'Nexa, sans-serif',
                  lineHeight: '1.1',
                }}
            >
              Provide Your Booking Details
            </Typography>
          </Grid>


        </Grid>


        <Grid item xs={12} md={12}>
          <Typography variant="h5" sx={{
            textAlign: 'left',
            color: '#444',
            font: '18px arial,serif',
            fontFamily: 'Nexa,sans-serif',
            fontWeight: 'bold', marginTop: '10px'
          }}>
            Lead Passenger Details
          </Typography>
        </Grid>
        <Box component="form" id="booking-form" noValidate onSubmit={handleSubmit} sx={{ mt: 3 }}>
          <Grid container spacing={2} alignItems="center">

            <Grid item xs={12} sm={12} md={12}>

              <TextField
                  required
                  fullWidth
                  id="email"
                  label="Email Address"
                  name="email"
                  autoComplete="email"
                  type="email"
                  onBlur={handleEmail}
                  error={!!errors.email}
                  helperText={errors.email}
                  InputProps={{
                    startAdornment: (
                        <InputAdornment position="end">
                          <EmailIcon />
                        </InputAdornment>
                    ),
                  }}
                  autoFocus
              />

            </Grid>


            <Grid item xs={12} sm={12} md={12}>
              <TextField
                  autoComplete="given-name"
                  name="firstName"
                  required
                  fullWidth
                  id="firstName"
                  label="First Name"
                  onBlur={handleFirstName}
                  error={!!errors.firstName}
                  helperText={errors.firstName}
                  InputProps={{
                    startAdornment: (
                        <InputAdornment position="end">
                          <img
                              src={PersonIconPng}
                              alt="Person Icon"
                              width="24"
                              height="24"
                              style={{ marginRight: 8 }}
                          />
                        </InputAdornment>
                    ),
                  }}
              />

            </Grid>


            <Grid item xs={12} sm={12} md={12}>
              <TextField
                  required
                  fullWidth
                  id="lastName"
                  onBlur={handleLastName}
                  label="Last Name"
                  name="lastName"
                  autoComplete="family-name"
                  error={!!errors.lastName}
                  helperText={errors.lastName}
                  InputProps={{
                    startAdornment: (
                        <InputAdornment position="end">
                          <img
                              src={PersonIconPng}
                              alt="Person Icon"
                              width="24"
                              height="24"
                              style={{ marginRight: 8 }}
                          />
                        </InputAdornment>
                    ),
                  }}
              />

            </Grid>


            <Grid item xs={12} sm={12} md={12}>



              <FormControl fullWidth error={!!errors.phone} required>


                <PhoneInput
                    specialLabel="Mobile *"
                    country={'gb'}
                    preferredCountries={preferedCountries}
                    placeholder="+44 7876 562361"
                    containerStyle={{ width: '100%' }}
                    inputStyle={{ width: '100%' }}
                    id="phone"
                    name="phone"
                    value={phone}
                    variant="outlined"
                    countryCodeEditable={false}
                    disableAreaCodes
                    onChange={(value) => {
                      const formattedValue = `+${value}`;
                      setPhone(formattedValue); // Update the 'phone' state with the full phone number
                    }}
                    onBlur={handlePhone}
                    inputProps={{
                      name: 'phone',
                      required: true,
                    }}
                />


                <FormHelperText style={{ color: 'red' }}>
                  {errors.phone ? errors.phone : ' '}
                </FormHelperText>
              </FormControl>

            </Grid>




            <Grid item xs={12} md={12}>
              <Typography variant="h5" sx={{
                textAlign: 'left',
                color: '#444',
                font: '18px arial,serif',
                fontFamily: 'Nexa,sans-serif',
                fontWeight: 'bold'
              }}>
                Travel Details
              </Typography>
            </Grid>




            {/* Outbound Flight/Travel Number Field */}
                    <Grid item xs={12} sm={12} md={12}  sx={{ display: resToRes ? 'none' : 'block' }}>
                      <TextField
                          required={!resToRes}
                          fullWidth
                          id="outboundFlightNumber"
                          label={outboundTransportLabel}
                          name="outboundFlightNumber"
                          autoComplete="flightNumber"
                          variant="outlined"
                          onBlur={handleOutboundFlightNumber}
                          error={!!errors.outboundFlightNumber}
                          helperText={errors.outboundFlightNumber}
                          InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                  <FlightIcon />
                                </InputAdornment>
                            ),
                          }}
                      />
                    </Grid>

            {/* Return Flight/Travel Number Field - only for return bookings */}
                  {isReturnJourney && (
                  <Grid item xs={12} sm={12} md={12}  sx={{ display: resToRes ? 'none' : 'block' }}>
                    <TextField
                        required={!resToRes}
                        fullWidth
                        id="returnFlightNumber"
                        label={`Return ${transportTypeReturn}`}
                        name="returnFlightNumber"
                        autoComplete="returnFlightNumber"
                        variant="outlined"
                        onBlur={handleInboundFlightNumber}
                        error={!!errors.inboundFlightNumber}
                        helperText={errors.inboundFlightNumber}
                        InputProps={{
                          startAdornment: (
                              <InputAdornment position="start">
                                <FlightIcon />
                              </InputAdornment>
                          ),
                        }}
                    />
                  </Grid>)}








            {createBookingResponse.basket.transfers[0].transferType.code !== "SCHD" ? (
                <>
                  <Grid item xs={12} sm={12} md={12}>
                    <TextField
                        required
                        fullWidth
                        id="accommodationName"
                        label="Accommodation Name"
                        name="accommodationName"
                        autoComplete="accommodationName"
                        onBlur={handleAccomodationName}
                        error={!!errors.accommodationName}
                        helperText={errors.accommodationName}
                        InputProps={{
                          startAdornment: (
                              <InputAdornment position="start">
                                <HomeIcon />
                              </InputAdornment>
                          ),
                        }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={12} md={12}>
                    <TextField
                        fullWidth
                        id="accommodationAddress"
                        label="Accommodation Address"
                        name="accommodationAddress"
                        autoComplete="accommodationAddress"
                        InputProps={{
                          startAdornment: (
                              <InputAdornment position="start">
                                <HomeIcon />
                              </InputAdornment>
                          ),
                        }}
                    />
                  </Grid>

                  {!resToRes && createBookingResponse.basket.transfers.length > 1 && (
                      <Grid item xs={12} md={12}>
                        <FormControlLabel
                            control={<Checkbox value="allowExtraEmails" color="primary" checked={isPickupChecked} onChange={handleCheckboxChange} />}
                            label="Pick up from the same address?"
                        />
                      </Grid>)}
                </>
            ) : (
                <>
                  {/* Bus-related fields */}



                  <Grid item xs={12} md={12}>
                    <Typography variant="h5" sx={{
                      textAlign: 'left',
                      color: '#444',
                      font: '18px arial,serif',
                      fontFamily: 'Nexa,sans-serif',
                      fontWeight: 'bold'
                    }}>
                      Bus Details
                    </Typography>
                  </Grid>

                  {/* Outbound Bus Station */}
                  <Grid item xs={12} md={12}>
                    <FormControl fullWidth sx={{ marginTop: '16px' }} error={outboundBusStationError}>
                      <InputLabel id="outbound-bus-station-label" required>
                        Outbound Bus Station
                      </InputLabel>
                      <Select
                          labelId="outbound-bus-station-label"
                          id="outbound-bus-station"
                          value={outboundBusStation}
                          label="Outbound Bus Station"
                          onChange={(event) => setOutBoundBusStation(event.target.value)}
                          fullWidth
                          required
                          startAdornment={
                            <InputAdornment position="start">
                              <BusIcon />
                            </InputAdornment>
                          }
                          sx={{
                            '& .MuiSelect-icon': { display: 'none' },
                            '& fieldset': { transition: 'border-color 0.3s' },
                            '&:hover fieldset': { borderColor: 'primary.main' },
                          }}
                      >
                        {
                          (() => {
                            if (createBookingResponse.basket.transfers[0].fromDestination.destinationTypeCode === 'AIR' && createBookingResponse.basket.transfers[0].toDestination.destinationTypeCode === 'RES') {
                              // If condition is met, render stopsTo for transfers[1]
                              return createBookingResponse?.basket?.transfers[0]?.shuttle?.options?.stopsTo.map((stop) => (
                                  <MenuItem key={stop.id} value={stop}>
                                    {stop.options}
                                  </MenuItem>
                              ));
                            }
                            else if (createBookingResponse.basket.transfers[0].fromDestination.destinationTypeCode === 'RES' && createBookingResponse.basket.transfers[0].toDestination.destinationTypeCode === 'AIR') {
                              return createBookingResponse?.basket?.transfers[0]?.shuttle?.options?.stopsFrom.map((stop) => (
                                  <MenuItem key={stop.id} value={stop}>
                                    {stop.options}
                                  </MenuItem>
                              ));
                            }
                            else {
                              // Otherwise, render stopsFrom for transfers[0]
                              return createBookingResponse?.basket?.transfers[0]?.shuttle?.options?.stopsFrom.map((stop) => (
                                  <MenuItem key={stop.id} value={stop}>
                                    {stop.options}
                                  </MenuItem>
                              ));
                            }
                          })()
                        }


                      </Select>

                    </FormControl>
                  </Grid>


                  {/* Oubound Bus Number */}
                  <Grid item xs={12} md={12}>
                    <FormControl fullWidth sx={{ marginTop: '16px' }} error={outboundBusNumberError}>
                      <InputLabel id="outbound-bus-number-label" required>
                        Outbound Bus Number
                      </InputLabel>
                      <Select
                          labelId="outbound-bus-number-label"
                          id="outbound-bus-number"
                          value={outboundBusNumber}
                          label="Outbound Bus Number"
                          onChange={(event) => setOutboundBusNumber(event.target.value)}
                          fullWidth
                          required
                          startAdornment={
                            <InputAdornment position="start">
                              <BusIcon />
                            </InputAdornment>
                          }
                          sx={{
                            '& .MuiSelect-icon': { display: 'none' },
                            '& fieldset': { transition: 'border-color 0.3s' },
                            '&:hover fieldset': { borderColor: 'primary.main' },
                          }}
                      >


                        {
                          (() => {
                            if (createBookingResponse.basket.transfers[0].fromDestination.destinationTypeCode === 'AIR' && createBookingResponse.basket.transfers[0].toDestination.destinationTypeCode === 'RES') {
                              // Render items for AIR to RES condition
                              return createBookingResponse.basket.transfers[0]?.shuttle?.options?.times.map((time) => (
                                  <MenuItem key={time.id} value={time}>{time.options}</MenuItem>
                              ));
                            } else if (createBookingResponse.basket.transfers[0].fromDestination.destinationTypeCode === 'RES' && createBookingResponse.basket.transfers[0].toDestination.destinationTypeCode === 'AIR') {
                              // Render items for RES to AIR condition, assuming the same action as AIR to RES for this example
                              return createBookingResponse.basket.transfers[0]?.shuttle?.options?.times.map((time) => (
                                  <MenuItem key={time.id} value={time}>{time.options}</MenuItem>
                              ));
                            } else {
                              // Render items if neither of the above conditions are met
                              return createBookingResponse.basket.transfers[1]?.shuttle?.options?.times.map((time) => (
                                  <MenuItem key={time.id} value={time}>{time.options}</MenuItem>
                              ));
                            }
                          })()
                        }

                      </Select>
                    </FormControl>
                  </Grid>



                  {/* Return Bus Station */}
                  {createBookingResponse.basket.transfers[1] && (
                      <Grid item xs={12} md={12}>
                        <FormControl fullWidth sx={{ marginTop: '16px' }} error={returnBusStationError}>
                          <InputLabel id="return-bus-station-label" required>
                            Return Bus Station
                          </InputLabel>
                          <Select
                              labelId="return-bus-station-label"
                              id="return-bus-station"
                              value={returnBusStation}
                              label="Return Bus Station"
                              onChange={(event) => setReturnBusStation(event.target.value)}
                              fullWidth
                              required
                              startAdornment={
                                <InputAdornment position="start">
                                  <BusIcon />
                                </InputAdornment>
                              }
                              sx={{
                                '& .MuiSelect-icon': { display: 'none' },
                                '& fieldset': { transition: 'border-color 0.3s' },
                                '&:hover fieldset': { borderColor: 'primary.main' },
                              }}
                          >
                            {
                              (() => {
                                if (createBookingResponse.basket.transfers[0].fromDestination.destinationTypeCode === 'AIR' && createBookingResponse.basket.transfers[0].toDestination.destinationTypeCode === 'RES') {
                                  // If condition is met, render stopsTo for transfers[1]
                                  return createBookingResponse?.basket?.transfers[0]?.shuttle?.options?.stopsTo.map((stop) => (
                                      <MenuItem key={stop.id} value={stop}>
                                        {stop.options}
                                      </MenuItem>
                                  ));
                                }
                                else if (createBookingResponse.basket.transfers[0].fromDestination.destinationTypeCode === 'RES' && createBookingResponse.basket.transfers[0].toDestination.destinationTypeCode === 'AIR') {
                                  return createBookingResponse?.basket?.transfers[1]?.shuttle?.options?.stopsTo.map((stop) => (
                                      <MenuItem key={stop.id} value={stop}>
                                        {stop.options}
                                      </MenuItem>
                                  ));
                                }
                                else {
                                  // Otherwise, render stopsFrom for transfers[0]
                                  return createBookingResponse?.basket?.transfers[0]?.shuttle?.options?.stopsFrom.map((stop) => (
                                      <MenuItem key={stop.id} value={stop}>
                                        {stop.options}
                                      </MenuItem>
                                  ));
                                }
                              })()
                            }


                          </Select>
                        </FormControl>
                      </Grid>)}

                  {/* Return Bus Number */}
                  {createBookingResponse.basket.transfers[1] && (
                      <Grid item xs={12} md={12}>
                        <FormControl fullWidth sx={{ marginTop: '16px' }} error={returnBusNumberError}>
                          <InputLabel id="return-bus-number-label" required>
                            Return Bus Number
                          </InputLabel>
                          <Select
                              labelId="return-bus-number-label"
                              id="return-bus-number"
                              value={returnBusNumber}
                              label="Return Bus Number"
                              onChange={(event) => setReturnBusNumber(event.target.value)}
                              fullWidth
                              required
                              startAdornment={
                                <InputAdornment position="start">
                                  <BusIcon />
                                </InputAdornment>
                              }
                              sx={{
                                '& .MuiSelect-icon': { display: 'none' },
                                '& fieldset': { transition: 'border-color 0.3s' },
                                '&:hover fieldset': { borderColor: 'primary.main' },
                              }}
                          >
                            {
                              (() => {
                                if (createBookingResponse.basket.transfers[0].fromDestination.destinationTypeCode === 'AIR' && createBookingResponse.basket.transfers[0].toDestination.destinationTypeCode === 'RES') {
                                  // Render items for AIR to RES condition
                                  return createBookingResponse.basket.transfers[1]?.shuttle?.options?.times.map((time) => (
                                      <MenuItem key={time.id} value={time}>{time.options}</MenuItem>
                                  ));
                                } else if (createBookingResponse.basket.transfers[0].fromDestination.destinationTypeCode === 'RES' && createBookingResponse.basket.transfers[0].toDestination.destinationTypeCode === 'AIR') {
                                  // Render items for RES to AIR condition, assuming the same action as AIR to RES for this example
                                  return createBookingResponse.basket.transfers[1]?.shuttle?.options?.times.map((time) => (
                                      <MenuItem key={time.id} value={time}>{time.options}</MenuItem>
                                  ));
                                } else {
                                  // Render items if neither of the above conditions are met
                                  return createBookingResponse.basket.transfers[1]?.shuttle?.options?.times.map((time) => (
                                      <MenuItem key={time.id} value={time}>{time.options}</MenuItem>
                                  ));
                                }
                              })()
                            }
                          </Select>
                        </FormControl>
                      </Grid>
                  )}
                </>
            )}




            {/* Children Age */}




            {!isPickupChecked && (
                <>
                  <Grid item xs={12} md={12}>
                    <Typography variant="h5" sx={{
                      textAlign: 'left',
                      color: '#444',
                      font: '18px arial,serif',
                      fontFamily: 'Nexa,sans-serif',
                      fontWeight: 'bold',
                    }}>
                      {resToRes ? `Return Details` : `Pickup Details`}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={9}>
                    <TextField
                        required
                        fullWidth
                        id="pickupAccommodationName"
                        label="Accommodation Name"
                        name="pickupAccommodationName"
                        autoComplete="pickupAccommodationName"
                        InputProps={{
                          startAdornment: (
                              <InputAdornment position="start">
                                <HomeIcon />
                              </InputAdornment>
                          ),
                        }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={9}>
                    <TextField
                        fullWidth
                        id="pickupAccommodationAddress"
                        label="Accommodation Address"
                        name="pickupAccommodationAddress"
                        autoComplete="pickupAccommodationAddress"
                        InputProps={{
                          startAdornment: (
                              <InputAdornment position="start">
                                <HomeIcon />
                              </InputAdornment>
                          ),
                        }}
                    />
                  </Grid>
                </>
            )}


            {/* // Children Details */}

            {travelDetails.childrenCount.length > 0 && (
                <Grid item xs={12} md={12}>
                  <Typography variant="h5" sx={{
                    textAlign: 'left',
                    color: '#444',
                    font: '18px arial,serif',
                    fontFamily: 'Nexa,sans-serif',
                    fontWeight: 'bold'
                  }}>
                    Children Details
                  </Typography>
                </Grid>
            )}


            {travelDetails.childrenCount.length > 0 && (
                travelDetails.childrenCount.map((child, index) => (
                    <Grid item xs={12} md={4} sx={{}} key={index}>
                      <Typography variant="h5" sx={{
                        textAlign: 'left',
                        color: '#444',
                        font: '20px arial,serif',
                        fontFamily: 'Nexa,sans-serif',
                        fontWeight: 'bold', marginTop: '10px', marginBottom: '30px'
                      }}>
                        Child {index + 1}
                      </Typography>
                      <FormControl sx={{ m: 1, minWidth: 250 }}>
                        <InputLabel id={`child-age-label-${index}`} sx={{ textAlign: 'center' }}>Child Age</InputLabel>
                        <Select
                            labelId={`child-age-label-${index}`}
                            id={`child-age-${index}`}
                            label="Child Age"
                            onChange={(event) => handleChildAgeChange(event, index)}
                            MenuProps={{
                              disablePortal: true,
                              variant: 'menu',
                            }}
                            style={{ textAlign: 'center' }}
                            fullWidth
                            required={true}
                        >

                          <MenuItem value="0" sx={{
                            display: 'block',
                            textAlign: 'center'
                          }}>
                            <em>Under 1</em>
                          </MenuItem>
                          {[...Array(15)].map((_, ageIndex) => (
                              <MenuItem key={ageIndex} value={ageIndex + 1} sx={{
                                display: 'block',
                                textAlign: 'center'
                              }}>
                                {ageIndex + 1}
                              </MenuItem>
                          ))}
                        </Select>
                        {index === childAges.length - 1 && renderChildAgeError()}
                      </FormControl>

                      <FormControl sx={{ m: 1, minWidth: 250 }}>
                        <InputLabel id={`child-seat-label-${index}`}>Child Seat</InputLabel>
                        <Select
                            labelId={`child-seat-label-${index}`}
                            id={`child-seat-${index}`}
                            label="Child Seat"
                            onChange={(event) => handleChildSeatChange(event, index)}
                            fullWidth
                            sx={{ textAlign: 'center' }}
                        >

                          <MenuItem value="Not Required" sx={{
                            display: 'block',
                            textAlign: 'center'
                          }}>
                            Not Required
                          </MenuItem>
                          <MenuItem value="Baby" sx={{
                            display: 'block',
                            textAlign: 'center'
                          }}>
                            Baby
                          </MenuItem>
                          <MenuItem value="Booster" sx={{
                            display: 'block',
                            textAlign: 'center'
                          }}>
                            Booster
                          </MenuItem>
                        </Select>

                      </FormControl>
                    </Grid>
                )))}






            <Grid item xs={12} md={12}>
              <Typography variant="h5" sx={{
                textAlign: 'left',
                color: '#444',
                font: '18px arial,serif',
                fontFamily: 'Nexa,sans-serif',
                fontWeight: 'bold',
              }}>
                Luggage and Extras
              </Typography>
            </Grid>


            <Grid item xs={12} md={4} >
              <TextField
                  label="Hold Luggage"
                  InputProps={{
                    readOnly: true, // Make the TextField non-editable
                    startAdornment: (
                        <InputAdornment position="start">
                          <img
                              src={LuggageIcon}
                              alt="Person Icon"
                              width="27"
                              height="27"
                          />

                        </InputAdornment>
                    ),
                    endAdornment: (
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <IconButton color="primary" onClick={handleDecreaseHoldLuggage}>
                            <RemoveIcon />
                          </IconButton>
                          <span style={{ marginLeft: '8px', marginRight: '8px' }}>{holdLuggageQty}</span>
                          <IconButton color="primary" onClick={handleIncreaseHoldLuggage}>
                            <AddIcon />
                          </IconButton>
                          <Typography variant="body2" sx={{
                            marginLeft: '10px',
                            color: '#999',
                            fontSize: '0.875rem',
                            display: 'flex',
                            alignItems: 'center'
                          }}>

                            <Tooltip title={LuggageLongText} placement="bottom" enterTouchDelay={0} leaveTouchDelay={5000}>
                              <InfoIcon fontSize="medium" />
                            </Tooltip>

                          </Typography>
                        </div>
                    ),
                  }}
                  fullWidth
              />
            </Grid>

            <Grid item xs={12} md={4} >
              <TextField
                  variant="outlined"
                  label="Skis/Snowboards"
                  InputProps={{
                    readOnly: true, // Make the TextField non-editable
                    startAdornment: (
                        <InputAdornment position="start">
                          <DownhillSkiingIcon />
                        </InputAdornment>
                    ),
                    endAdornment: (
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <IconButton color="primary" onClick={handleDecreaseSkisSnowboards}>
                            <RemoveIcon />
                          </IconButton>
                          <span style={{ marginLeft: '8px', marginRight: '8px' }}>{skisSnowboardsQty}</span>
                          <IconButton color="primary" onClick={handleIncreaseSkisSnowboards}>
                            <AddIcon />
                          </IconButton>
                          <Typography variant="body2" sx={{
                            marginLeft: '10px',
                            color: '#999',
                            fontSize: '0.875rem',
                            display: 'flex',
                            alignItems: 'center'
                          }}>
                            <Tooltip title={SkisLongText} placement="bottom" enterTouchDelay={0} leaveTouchDelay={5000}>
                              <InfoIcon fontSize="medium" />
                            </Tooltip>
                          </Typography>
                        </div>
                    ),
                  }}
                  fullWidth
              />
            </Grid>

            <Grid item xs={12} md={4} >
              <TextField
                  variant="outlined"
                  label="Bikes/Golf Bags"
                  InputProps={{
                    readOnly: true, // Make the TextField non-editable
                    startAdornment: (
                        <InputAdornment position="start">
                          <GolfCourseIcon />
                        </InputAdornment>
                    ),
                    endAdornment: (
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <IconButton color="primary" onClick={handleDecreaseBikesGolfBags}>
                            <RemoveIcon />
                          </IconButton>
                          <span style={{ marginLeft: '8px', marginRight: '8px' }}>{bikesGolfBagsQty}</span>
                          <IconButton color="primary" onClick={handleIncreaseBikesGolfBags}>
                            <AddIcon />
                          </IconButton>
                          <Typography variant="body2" sx={{
                            marginLeft: '10px',
                            color: '#999',
                            fontSize: '0.875rem',
                            display: 'flex',
                            alignItems: 'center'
                          }}>
                            <Tooltip title={GolfBagsLongText} placement="bottom" enterTouchDelay={0} leaveTouchDelay={5000}>
                              <InfoIcon fontSize="medium" />
                            </Tooltip>
                          </Typography>
                        </div>
                    ),
                  }}
                  fullWidth
              />
            </Grid>
          </Grid>







          <Grid item xs={12} md={12} sx={{ marginTop: '25px' }}>
            <Typography variant="h5" sx={{
              textAlign: 'left',
              color: '#444',
              font: '18px arial,serif',
              fontFamily: 'Nexa,sans-serif',
              fontWeight: 'bold', marginBottom: '12px'
            }} >
              Notes / Special Requirements
            </Typography>
          </Grid>

          <Grid item xs={12} md={12}>
            <TextField
                id="notes"
                name="notes"
                autoComplete="notes"
                multiline
                rows={4}
                fullWidth
            />
          </Grid>



          <Grid item sm={12} md={12} sx={{ display: 'flex', justifyContent: 'center' }}>
            {loading ? (
                <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', marginTop: '20px' }}>
                  <Typography variant="body1" color="grey" style={{ marginTop: '10px' }}>
                    Processing...
                  </Typography>
                  <br />
                  <CircularProgress size={48} style={{ marginBottom: '8px', color: 'grey' }} />
                </div>
            ) : (
                showSubmitButton && (
                    <Button
                        id={'bookingFormContinueButton'}
                        type="submit"
                        variant="contained"
                        style={{
                          mt: 3, mb: 2, backgroundColor: 'rgb(17, 137, 17)',
                          color: 'rgb(255, 255, 255)',
                          borderRadius: '6px',
                          marginTop: '14px',
                          padding: '0px 50px',
                          fontFamily: '"Nexa","Arial",sans-serif!important',
                          fontWeight: 'bold',
                          fontSize: '1rem',
                          lineHeight: '1.75',
                          letterSpacing: '0.02857em',
                          minWidth: '183px',
                          minHeight: '50px',
                          display: 'flex', justifyContent: 'center'
                        }}
                    >
                      Continue
                    </Button>
                )
            )}
          </Grid>

        </Box>
        {showLoginComponent ? (
            // Render the Login Component
            <Login />
        ) : null
        }

      </div>
  );
};

export default withStyles(styles, { withTheme: true })(BookingJourneyForm);
